import { css, cx } from '@linaria/core';
import { styled } from '@linaria/react';

import type { TMedia } from '~constants/media';
import { ImageRenderer } from '~shared/ui/molecules';

import TickSimple from '../../../../../public/assets/icons/tick-simple.svg';

const Wrapper = styled.div<{ size: number }>`
	--avatar-size: ${({ size }) => size + 'px'};
	position: relative;
	width: var(--avatar-size);
	height: var(--avatar-size);
	font-size: 0;
`;

const img = css`
	overflow: hidden;
	border-radius: 100%;
`;

const InfluencerMark = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
`;

type Props = {
	className?: string;
	avatar?: TMedia[];
	avatarFallback?: string;
	size?: number;
	ticked?: boolean;
};

export const Avatar = ({
	className,
	avatar,
	avatarFallback = '/img/botPlaceholder.webp',
	size = 48,
	ticked,
}: Props) => {
	return (
		<Wrapper size={size}>
			<ImageRenderer
				className={cx(className, img)}
				item={avatar}
				fallback={avatarFallback}
				width={size}
				height={size}
				alt=""
			/>
			{ticked && (
				<InfluencerMark>
					<TickSimple />
				</InfluencerMark>
			)}
		</Wrapper>
	);
};
